// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"2bfa75a0","997":"211da161"}[chunkId] + ".chunk.js";
};